import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "login-register-wrap"
};
const _hoisted_2 = {
  class: "login-register-content"
};
const _hoisted_3 = {
  class: "login-register-left"
};
const _hoisted_4 = {
  class: "login-wrap"
};
const _hoisted_5 = {
  class: "login-btn"
};
const _hoisted_6 = {
  class: "register"
};
const _hoisted_7 = {
  key: 1,
  class: "empty-img-verify"
};
const _hoisted_8 = {
  class: "login-register-right"
};
const _hoisted_9 = {
  class: "website-title"
};
const _hoisted_10 = {
  class: "website-sub"
};
import { ref, reactive, onMounted, onUnmounted } from "vue";
import { Iphone, Lock, ChatRound, Close, Postcard, UserFilled, WarnTriangleFilled } from "@element-plus/icons-vue";
import { user_register, user_login, send_code, valid_code, get_user_group, get_code } from "@/api/api-serive";
import { ElMessage } from "element-plus";
import { checkPhone } from "@/utils/verfifcation";
import IdentityCodeValid from "@/utils/checkIdent";
import mymd5 from "@/hook/index";
import { setCookie } from "@/utils/storage";
import { getBirthday, getSex } from "@/utils/idcard";
import { useStore } from "vuex";
import Config from "@/api/config";
// ==================== 常量配置 ====================
const CODE_LENGTH = 6;
const PASSWORD_MIN_LENGTH = 6;
const PASSWORD_MAX_LENGTH = 15;
const COUNTDOWN_SECONDS = 60;
const MESSAGE_OFFSET = 160;
const SUCCESS_CODE = 200;
// ==================== Props & Emits ====================
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginRegister',
  props: {
    activeName: String,
    activeType: Number
  },
  emits: ["updateDialog", "updateLogin", "updateRealName"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    // ==================== Store ====================
    const store = useStore();
    // ==================== 状态定义 ====================
    const websitename = ref(process.env.VUE_APP_PAGES_TITLE || "系统");
    const websitesub = ref(process.env.VUE_APP_SUB_TITLE || "");
    const loginType = ref("password");
    const loginForm = reactive({
      mobile: "",
      password: "",
      msgcode: "",
      groupId: ""
    });
    const registerForm = reactive({
      mobile: "",
      realName: "",
      idcard: "",
      password: "",
      msgcode: ""
    });
    const sendText = ref("发送验证码");
    const sendFlag = ref(false);
    const activeName = ref(props.activeName || "login");
    const activeType = ref(props.activeType || 1);
    const groupList = ref([]);
    const dialogVisible = ref(false);
    const email = ref(Config.e_mail);
    const tel = ref(Config.tel);
    const imgCode = ref("");
    const loading = ref(false);
    const registerLoading = ref(false);
    const forgetContent = ref(`请联系管理员${tel.value}，或<br>将姓名、手机号、身份证号发送至<br>邮箱${email.value}进行密码重置。`);
    // ==================== 倒计时逻辑 ====================
    let countdownTimer = null;
    const countdown = () => {
      let count = COUNTDOWN_SECONDS;
      sendFlag.value = true;
      sendText.value = `${count}秒后重试`;
      countdownTimer = window.setInterval(() => {
        count--;
        if (count <= 0) {
          sendFlag.value = false;
          dialogVisible.value = false;
          sendText.value = "发送验证码";
          if (countdownTimer) {
            clearInterval(countdownTimer);
            countdownTimer = null;
          }
          return;
        }
        sendText.value = `${count}秒后重试`;
      }, 1000);
    };
    // ==================== 接口请求 ====================
    const sendCode = params => {
      send_code(params).then(success => {
        if (SUCCESS_CODE === success.code) {
          countdown();
        } else {
          ElMessage({
            type: "warning",
            message: success.message,
            offset: MESSAGE_OFFSET
          });
        }
      }).catch(err => {
        console.error(err);
        ElMessage({
          type: "error",
          message: "发送验证码失败",
          offset: MESSAGE_OFFSET
        });
      });
    };
    const validCode = (params, lrParams) => {
      valid_code(params).then(success => {
        if (SUCCESS_CODE === success.code) {
          if (activeName.value === "login") {
            // 短信登录时删除 password 参数（原有逻辑）
            delete lrParams.password;
            userLogin(lrParams);
          } else {
            userRegister(lrParams);
          }
        } else {
          ElMessage({
            type: "warning",
            message: success.message,
            offset: MESSAGE_OFFSET
          });
        }
      }).catch(err => {
        console.error(err);
        ElMessage({
          type: "error",
          message: "验证码校验失败",
          offset: MESSAGE_OFFSET
        });
      });
    };
    const userRegister = params => {
      registerLoading.value = true;
      user_register(params).then(success => {
        if (SUCCESS_CODE === success.code) {
          ElMessage({
            type: "success",
            message: "注册成功",
            offset: MESSAGE_OFFSET
          });
          activeName.value = "login";
          // 清空注册表单
          Object.assign(registerForm, {
            mobile: "",
            realName: "",
            idcard: "",
            password: "",
            msgcode: ""
          });
        } else {
          ElMessage({
            type: "warning",
            message: success.message,
            offset: MESSAGE_OFFSET
          });
        }
      }).catch(err => {
        console.error(err);
        ElMessage({
          type: "error",
          message: "注册失败，请联系管理员！",
          offset: MESSAGE_OFFSET
        });
      }).finally(() => {
        registerLoading.value = false;
      });
    };
    const userLogin = params => {
      loading.value = true;
      user_login(params).then(success => {
        if (SUCCESS_CODE === success.code) {
          const userInfo = success.data;
          // 存储 token
          sessionStorage.setItem("token", userInfo.token);
          ElMessage({
            type: "success",
            message: "登录成功",
            offset: MESSAGE_OFFSET
          });
          emit("updateDialog", false);
          emit("updateLogin", true);
          setCookie({
            userName: userInfo.userName,
            realName: userInfo.realName
          });
          emit("updateRealName", userInfo.realName);
          // 通过 Vuex 存储登录状态
          store.commit("SET_LOGIN_STATUS", true);
          window.location.reload();
        } else {
          ElMessage({
            type: "error",
            message: success.message + "，账号或密码错误！",
            offset: MESSAGE_OFFSET
          });
        }
      }).catch(err => {
        console.error(err);
        ElMessage({
          type: "error",
          message: "登录失败，请联系管理员！",
          offset: MESSAGE_OFFSET
        });
      }).finally(() => {
        loading.value = false;
      });
    };
    // ==================== 表单验证规则 ====================
    const loginFormRef = ref();
    const validatePhone = (rule, val, callback) => {
      if (val === "") {
        return callback(new Error("请输入手机号"));
      } else if (!checkPhone(val)) {
        return callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, val, callback) => {
      if (val === "") {
        return callback(new Error("请输入密码"));
      } else if (val.length < PASSWORD_MIN_LENGTH || val.length > PASSWORD_MAX_LENGTH) {
        return callback(new Error(`请输入${PASSWORD_MIN_LENGTH}到${PASSWORD_MAX_LENGTH}位字符`));
      } else {
        callback();
      }
    };
    const validateMsgcode = (rule, val, callback) => {
      if (val === "") {
        return callback(new Error("请输入短信验证码"));
      } else if (val.length !== CODE_LENGTH) {
        return callback(new Error(`请输入${CODE_LENGTH}位数字验证码`));
      } else {
        callback();
      }
    };
    const validateIdcard = (rule, val, callback) => {
      if (val === "") {
        return callback(new Error("请输入身份证号码"));
      } else if (!IdentityCodeValid(val.toUpperCase())) {
        return callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    const validateRealname = (rule, val, callback) => {
      if (val === "") {
        return callback(new Error("请输入真实姓名"));
      } else {
        callback();
      }
    };
    const loginRules = reactive({
      mobile: [{
        required: true,
        validator: validatePhone,
        trigger: "blur"
      }],
      password: [{
        required: true,
        validator: validatePassword,
        trigger: "blur"
      }],
      msgcode: [{
        required: true,
        validator: validateMsgcode,
        trigger: "blur"
      }]
    });
    const registerFormRef = ref();
    const registerRules = reactive({
      mobile: [{
        required: true,
        validator: validatePhone,
        trigger: "blur"
      }],
      realName: [{
        required: true,
        validator: validateRealname,
        trigger: "blur"
      }],
      idcard: [{
        required: true,
        validator: validateIdcard,
        trigger: "blur"
      }],
      password: [{
        required: true,
        validator: validatePassword,
        trigger: "blur"
      }],
      msgcode: [{
        required: true,
        validator: validateMsgcode,
        trigger: "blur"
      }]
    });
    // ==================== 事件处理 ====================
    const closeDialog = () => {
      emit("updateDialog", false);
    };
    const handleTabChange = name => {
      activeName.value = name;
    };
    const handleMobileChange = val => {
      if (!checkPhone(val)) return;
      if (activeName.value === "register") {
        get_code({
          mobile: val
        }).then(success => {
          if (SUCCESS_CODE === success.code) {
            imgCode.value = success.data;
          } else {
            imgCode.value = "";
          }
        }).catch(e => {
          console.error(e);
          imgCode.value = "";
        });
      } else {
        // 登录模式下，团体用户输入手机号后获取组列表
        get_user_group({
          phone: val
        }).then(success => {
          if (SUCCESS_CODE === success.code) {
            const data = success.data;
            if (data && data.length > 0) {
              groupList.value = data;
              loginForm.groupId = data[0].groupId;
            }
          }
        }).catch(e => {
          console.error(e);
        });
      }
    };
    const Login = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (!valid) return;
        if (activeType.value === 2 && !loginForm.groupId) {
          ElMessage({
            type: "error",
            message: "你不属于任何团体，请使用普通用户登录",
            offset: MESSAGE_OFFSET
          });
          return;
        }
        const params = {
          mobile: loginForm.mobile,
          password: mymd5(loginForm.password).value,
          thirdType: "PC"
        };
        if (loginType.value === "message") {
          validCode({
            mobile: loginForm.mobile,
            code: loginForm.msgcode
          }, params);
        } else {
          userLogin(params);
        }
      });
    };
    const sendMsgcode = formEl => {
      if (!formEl) return;
      formEl.validateField("mobile", mobileErr => {
        if (mobileErr) return;
        if (sendFlag.value) return;
        let mobile = null;
        if (activeName.value === "login") {
          mobile = loginForm.mobile || null;
        } else {
          mobile = registerForm.mobile || null;
        }
        if (mobile) {
          dialogVisible.value = true;
          sendCode({
            mobile
          });
        }
      });
    };
    const Register = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (!valid) return;
        const params = {
          mobile: registerForm.mobile,
          password: mymd5(registerForm.password).value,
          realName: registerForm.realName,
          idcard: registerForm.idcard,
          thirdType: "PC",
          sex: getSex(registerForm.idcard),
          birthday: getBirthday(registerForm.idcard)
        };
        validCode({
          mobile: registerForm.mobile,
          code: registerForm.msgcode
        }, params);
      });
    };
    // ==================== 键盘事件 ====================
    const handleKeydown = e => {
      if (e.key === "Enter" || e.keyCode === 13) {
        e.preventDefault();
        if (activeName.value === "login") {
          Login(loginFormRef.value);
        } else {
          Register(registerFormRef.value);
        }
      }
    };
    // ==================== 生命周期 ====================
    onMounted(() => {
      document.addEventListener("keydown", handleKeydown);
    });
    onUnmounted(() => {
      document.removeEventListener("keydown", handleKeydown);
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_img_verify = _resolveComponent("img-verify");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return !_ctx.$store.state.HomeModule.loginRegisterDialogShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tabs, {
        class: "login-register-tabs",
        type: "card",
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => activeName.value = $event),
        onTabChange: handleTabChange
      }, {
        default: _withCtx(() => [activeName.value == 'login' ? (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: 0,
          label: activeType.value == 2 ? '团体用户登录' : '普通用户登录',
          name: "login"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_radio_group, {
            modelValue: loginType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginType.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_button, {
              label: "password"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("密码登录")])),
              _: 1
            }), _createVNode(_component_el_radio_button, {
              label: "message"
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("短信登录")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _cache[23] || (_cache[23] = _createElementVNode("div", {
            style: {
              "margin": "20px"
            }
          }, null, -1)), _createVNode(_component_el_form, {
            "label-position": "top",
            model: loginForm,
            style: {
              "max-width": "460px"
            },
            ref_key: "loginFormRef",
            ref: loginFormRef,
            rules: loginRules
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: loginForm.mobile,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.mobile = $event),
                placeholder: "手机号码",
                onChange: handleMobileChange
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Iphone))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), loginType.value === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              prop: "password"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: loginForm.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => loginForm.password = $event),
                type: "password",
                "show-password": "",
                placeholder: "登录密码"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Lock))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), activeType.value === 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              prop: "groupId"
            }, {
              default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "mylabel"
              }, "所属团体", -1)), _createVNode(_component_el_select, {
                modelValue: loginForm.groupId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => loginForm.groupId = $event),
                placeholder: "所属团体",
                class: "myselect"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: item.groupId,
                    label: item.groupName,
                    value: item.groupId
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), loginType.value === 'message' ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              prop: "msgcode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: loginForm.msgcode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => loginForm.msgcode = $event),
                placeholder: "短信验证码"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(ChatRound))]),
                  _: 1
                })]),
                append: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = $event => sendMsgcode(loginFormRef.value)),
                  disabled: sendFlag.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(sendText.value), 1)]),
                  _: 1
                }, 8, ["disabled"])]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [loginType.value === 'password' ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_createVNode(_component_el_button, {
                size: "large",
                type: "primary",
                onClick: _cache[6] || (_cache[6] = $event => Login(loginFormRef.value)),
                loading: loading.value,
                style: {
                  "width": "80%"
                }
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode(" 登录 ")])),
                _: 1
              }, 8, ["loading"]), _createVNode(_component_el_tooltip, {
                content: forgetContent.value,
                "raw-content": "",
                placement: "left"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_text, {
                  class: "forget-password",
                  type: "warning"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode(" 忘记密码？ ")])),
                  _: 1
                })]),
                _: 1
              }, 8, ["content"])], 64)) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                size: "large",
                type: "primary",
                onClick: _cache[7] || (_cache[7] = $event => Login(loginFormRef.value)),
                loading: loading.value,
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [_createTextVNode(" 登录 ")])),
                _: 1
              }, 8, ["loading"]))])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "rules"])])]),
          _: 1
        }, 8, ["label"])) : (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: 1,
          label: "普通用户注册",
          name: "register"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
            "label-position": "top",
            model: registerForm,
            style: {
              "max-width": "460px"
            },
            ref_key: "registerFormRef",
            ref: registerFormRef,
            rules: registerRules
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "mobile"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: registerForm.mobile,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => registerForm.mobile = $event),
                placeholder: "手机号码",
                onChange: handleMobileChange
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Iphone))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "realName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: registerForm.realName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => registerForm.realName = $event),
                placeholder: "真实姓名"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "idcard"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: registerForm.idcard,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => registerForm.idcard = $event),
                placeholder: "身份证号码"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Postcard))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "password"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: registerForm.password,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => registerForm.password = $event),
                type: "password",
                "show-password": "",
                placeholder: "登录密码"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(Lock))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              prop: "msgcode"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: registerForm.msgcode,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => registerForm.msgcode = $event),
                placeholder: "验证码",
                class: "msgcode-input"
              }, {
                prepend: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: "large"
                }, {
                  default: _withCtx(() => [_createVNode(_unref(ChatRound))]),
                  _: 1
                })]),
                append: _withCtx(() => [imgCode.value ? (_openBlock(), _createBlock(_component_img_verify, {
                  key: 0,
                  imgCode: imgCode.value
                }, null, 8, ["imgCode"])) : (_openBlock(), _createElementBlock("div", _hoisted_7, " 输入手机号获取验证码 "))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                size: "large",
                type: "primary",
                onClick: _cache[13] || (_cache[13] = $event => Register(registerFormRef.value)),
                loading: registerLoading.value,
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode(" 注册 ")])),
                _: 1
              }, 8, ["loading"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "rules"])])]),
          _: 1
        }))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_9, _toDisplayString(websitename.value), 1), _createElementVNode("p", _hoisted_10, _toDisplayString(websitesub.value), 1)])]), _createElementVNode("div", {
        class: "close",
        onClick: closeDialog
      }, [_createVNode(_component_el_icon, {
        size: "24px"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })])]), _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => dialogVisible.value = $event),
        width: "300",
        center: "",
        "align-center": "",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        onClose: _cache[16] || (_cache[16] = $event => dialogVisible.value = false)
      }, {
        header: _withCtx(() => [_createVNode(_component_el_text, {
          type: "warning",
          style: {
            "font-size": "16px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(WarnTriangleFilled))]),
            _: 1
          }), _cache[25] || (_cache[25] = _createTextVNode("温馨提示 "))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_text, null, {
          default: _withCtx(() => [_cache[26] || (_cache[26] = _createTextVNode(" 如果长时间未收到短信，请联系客服人员。")), _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)), _cache[28] || (_cache[28] = _createTextVNode(" 客服电话：")), _createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tel.value), 1)]),
            _: 1
          }), _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)), _cache[30] || (_cache[30] = _createTextVNode(" 客服邮箱：")), _createVNode(_component_el_text, {
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(email.value), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true);
    };
  }
});